export default __webpack_public_path__ + "static/media/icon-tag.143400ef.svg";